export default __webpack_public_path__ + "static/media/Quiver of Barbed Tongues.b6966ee5.jpg";